import { render, staticRenderFns } from "./RsvpPage.vue?vue&type=template&id=515a2286"
import script from "./RsvpPage.vue?vue&type=script&lang=js"
export * from "./RsvpPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports